export default "__VITE_ASSET__D3N9dfBP__"